import React from 'react';
import { useTranslation } from 'react-i18next';
import BillOfSaleIcon from '../../../../public/static/images/item/bill_of_sale.svg';
import MortgageIcon from '../../../../public/static/images/item/mortgage.svg';
import RepairIcon from '../../../../public/static/images/item/repair.svg';
import Icon from '../../../Icon';
import { Typography } from '../../../ui/Typography';
import { ServicesSectionContainer, ServicesSectionItem } from './styled';

interface ServicesSectionProps {
  billOfSale?: boolean | null;
  mortgage?: boolean | null;
  repair?: boolean | null;
}

export const ServicesSection: React.FC<ServicesSectionProps> = ({
  billOfSale,
  mortgage,
  repair
}) => {
  const { t } = useTranslation();
  const isHideAllButtons = !billOfSale && !mortgage && !repair;

  const servicesList = [
    {
      title: t('pages.current_item.buttons.bill_of_sale'),
      icon: BillOfSaleIcon,
      isShow: billOfSale
    },
    {
      title: t('pages.current_item.buttons.mortgage'),
      icon: MortgageIcon,
      isShow: mortgage
    },
    {
      title: t('pages.current_item.buttons.repair'),
      icon: RepairIcon,
      isShow: repair
    }
  ].filter(item => item.isShow);

  if (isHideAllButtons) return null;

  return (
    <ServicesSectionContainer
      data-cy="services-section"
      $itemCount={servicesList.length}
    >
      {servicesList.map(({ title, icon }, i) => {
        return (
          <ServicesSectionItem key={i} data-cy="services-section__item">
            <Icon IconComponent={icon} width={15} height={15} indent={false} />
            <Typography tag="caption_1_new">{title}</Typography>
          </ServicesSectionItem>
        );
      })}
    </ServicesSectionContainer>
  );
};
